import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImgA55 from '../../assets/images/icon-client-a55.webp';
import ImgEnkorto from '../../assets/images/icon-client-enkorto.webp';
import ImgEmpagos from '../../assets/images/icon-client-enpagos.webp';
import ImgFinics from '../../assets/images/icon-client-finics.webp';
import FormContact from '../../components/FormContact';
import SliderClients from '../../components/SliderClients';
import { useWindowDimensions } from '../../utils';
import {
  ContContactPage,
  ContContactPageChild,
  ContRightSide,
  ContSliderClients,
  ContTitleContact,
  DescContact,
  GSRightSide,
  TitleContact,
} from './ContactPage.styles';

const Slider1 = [
  {
    name: 'Finics',
    link: 'http://finics.mx',
    displayLink: 'finics.mx/',
    logoBackground: '#ffffff',
    img: ImgFinics,
    desc: 'Con Dynamicore hemos podido acelerar significativamente los tiempos para operar. Gracias al equipo y a las integraciones ya listas, DynamiCore nos permitio enfocarnos en nuestro producto y propuesta de valor.',
  },
  {
    name: 'Enkorto',
    link: 'http://enkorto.mx',
    displayLink: 'enkorto.mx',
    logoBackground: '#1f2f56',
    img: ImgEnkorto,
    desc: 'Es muy grato contar con grandes aliados, sin duda, DynamiCore tiene un equipo de expertos que nos han acompanado en cada paso del desarrollo y lanzamiento de nuestra app de arrendamiento EnKorto.',
  },
  {
    name: 'A55',
    link: 'http://a55.mx',
    displayLink: 'a55.mx/',
    logoBackground: '#27a3f3',
    img: ImgA55,
    desc: 'DynamiCore es una empresa con experiencia en el campo, nos ha ayudado a gestionar adecuadamente el control interno y operaciones diarias de nuestros productos financieros <strong>!Es el mejor aliado!</strong>',
  },
  {
    name: 'Enpagos',
    link: 'http://enpagos.mx',
    displayLink: 'enpagos.mx/',
    logoBackground: '#ffffff',
    img: ImgEmpagos,
    desc: 'DynamiCore es una empresa con experiencia en el campo, nos ha ayudado a gestionar adecuadamente el control interno y operaciones diarias de nuestros productos financieros <strong>!Es el mejor aliado!</strong>',
  },
];

export const ContactPage = () => {
  const { t } = useTranslation();
  const { width, height } = useWindowDimensions();
  const [lessHeight, setLessHeight] = useState(81 + 93);
  const AUTOPLAY = true;
  const slidesToShow = 1;

  useEffect(() => {
    if (width >= 1920) {
      setLessHeight(height);
    } else if (width >= 1640) {
      setLessHeight(height);
    } else if (width >= 1440) {
      setLessHeight(height);
    } else if (width >= 1408) {
      setLessHeight(height + 30);
    } else if (width >= 1280) {
      setLessHeight(height);
    } else if (width >= 1080) {
      setLessHeight(height - (81 + 93 - 16));
    } else if (width >= 1024) {
      setLessHeight(height - (81 + 93 - 30));
    } else if (width >= 768) {
      setLessHeight(height - (81 + 93 - 16));
    }
  }, [width, height]);

  return (
    <ContContactPage>
      <GSRightSide />
      <ContContactPageChild>
        <ContRightSide height={lessHeight}>
          <ContTitleContact>
            <div>
              <TitleContact>
                {t('Â¡Transformamos tu financiera desde el Core!')}
              </TitleContact>
              <DescContact>
                {t('El Core Bancario que te ayuda a automatizar procesos y gestionar productos financieros digitales.')}
              </DescContact>
            </div>
            <ContSliderClients>
              <SliderClients
                data={Slider1}
                autoplay={AUTOPLAY}
                rtl={false}
                dots={true}
                infinite={true}
                slidesToShow={slidesToShow}
                slidesToScroll={1}
                speed={2000}
                autoplaySpeed={7000}
                arrows={false}
              />
            </ContSliderClients>
          </ContTitleContact>
        </ContRightSide>
      </ContContactPageChild>
      <ContContactPageChild>
        <FormContact />
      </ContContactPageChild>
    </ContContactPage>
  );
};
